import React, { useContext, useEffect } from 'react';
import grafika_2 from '../../assets/grafika_2.svg';
import FormContext from '../../contexts/FormContext';
import './FinalForm.css';

interface IStep3Form {
    setStep: React.Dispatch<React.SetStateAction<number>>;
}

const FinalForm = ({
    setStep
}: IStep3Form) => {
    const {
        number
    } = useContext(FormContext);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <p className="header">
                Dziękujemy!
            </p>
            <p className="mt-2">
                Twój wniosek o numerze <span className="bold">{number}</span> został złożony.
            </p>
            <span className="mt-2 red bold stepSize">
                Co dalej?
            </span>
            <p className="mt-1">
                Najpóźniej w kolejnym dniu roboczym otrzymasz:
            </p>
            <span className="bold mt-1">
                na adres e-mail:
            </span>
            <ul className='circleList'>
                <li><div className='circle' />Umowę Dostępu do naszego systemu - Platformy Xelion,</li>
                <li><div className='circle' />indywidualny Identyfikator,</li>
                <li><div className='circle' />link do logowania do naszego systemu - Platformy Xelion,</li>
            </ul>
            <span className="bold mt-1">
                na numer telefonu komórkowego:
            </span>
            <ul className='circleList'>
                <li><div className='circle' />SMS zawierający indywidualny Telekod.</li>
            </ul>
            <div className="imageCenter">
                <img src={grafika_2} width="250" alt="" />
            </div>
            <p className="mt-4 stepSize">
                <span className="red bold">Krok 1.</span> <span className='bold'>Logowanie do Platformy Xelion</span>
            </p>
            <ul className='listMargin'>
                <li> Skorzystaj z linku do logowania</li>
                <li>Wybierz opcję ,,Pierwsze logowanie".</li>
                <li>Korzystając z Identyfikatora i Telekodu, ustanów swoje hasło do logowania.</li>
                <li>Zaloguj się do Platformy Xelion.</li>
            </ul>
            <p className="mt-4 stepSize">
                <span className="red bold">Krok 2.</span> <span className='bold'>Zawarcie Umowy</span>
            </p>
            <ul className='listMargin'>
                <li>Uzupełnij niezbędne oświadczenia i ankiety.</li>
                <li>Zawrzyj Umowę o świadczenie usług maklerskich i innych usług przez Dom Inwestycyjny Xelion sp. z o.o.</li>
            </ul>
            <p className="mt-4 stepSize">
                <span className="red bold">Krok 3.</span> <span className='bold'>Inwestuj z nami!</span>
            </p>
            <button className="finalButton mt-4 mb-4 float-right" onClick={() => {
                window.location.href = 'https://www.xelion.pl/';
            }}>
                Przejdź do naszej strony www
            </button>
        </>
    );
};

export {
    FinalForm
}